module.exports = __webpack_public_path__ + "img/LOGO - Seed@2x.d1733dd9.png";